import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const notiService = {
  get_list_notis: async (token, params = {}) => {
    const response = await https.get(`${API_ROUTES.NOTI.GET_LIST_NOTIS}`, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },

  get_notis_count: async (token) => {
    const response = await https.get(`${API_ROUTES.NOTI.GET_NOTIS_COUNT}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  get_noti_by_id: async (notiId, token) => {
    const response = await https.get(
      `${API_ROUTES.NOTI.GET_NOTI_BY_ID}/${notiId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
